const routes = {
  dashboard: "/",
  connect: "/connect",
  wallet: "/wallet",
  history: "/history",
  developer: "/developer",
  createToken: "/create-token/list-token",
  createToken2: "/create-token/create",
  createToken3: "/create-token/create-my-token",
  createToken4: "/create-token/token-created",
  sendToken: "/wallet/send-token",
};

export default routes;
